import { OperatorType } from "../types/generalTypes";

export const OPERATORS: OperatorType[] = ["+", "-", "×", "÷"];
export const EMOJI_DIGITS = [
  "0️⃣",
  "1️⃣",
  "2️⃣",
  "3️⃣",
  "4️⃣",
  "5️⃣",
  "6️⃣",
  "7️⃣",
  "8️⃣",
  "9️⃣",
];

export const BG_DARK = "#212121";
export const BG_LIGHT = "#f5f5f5";

// export default OPERATORS;
